"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Singleton Instance having reference to all created GameAnimations. (primarly using spine.) allows us to control all together.
 * Provides access to all GameAnimations as well as alist of all of them.
 */
var GameAnimationRegistry = /*#__PURE__*/function () {
  function GameAnimationRegistry() {
    _classCallCheck(this, GameAnimationRegistry);
    _defineProperty(this, "_registery", void 0);
    _defineProperty(this, "currentTimeScale", 1);
    this._registery = [];

    //window['reg'] = this;
  }

  /**
   * Register a component with the resgistry.
   * @param animation 
   */
  return _createClass(GameAnimationRegistry, [{
    key: "register",
    value: function register(animation) {
      if (!animation.name) {
        throw new Error("Animation with no name, we dont allow that.");
      }
      this._registery.push(animation);
    }

    /**
     * Unregister/remove a component, called on destroy of the IGameComponent.
     * @param animation 
     */
  }, {
    key: "unregister",
    value: function unregister(animation) {
      var i = this._registery.findIndex(function (c) {
        return c == animation;
      });
      // note, splice with -1 will remove last entry. NOT GOOD. Unregiste should not be called on unnamed components but this should safe guard it.
      if (i > -1) this._registery.splice(i, 1);
    }

    /**
     * Get the Registry
     */
  }, {
    key: "registery",
    get: function get() {
      return this._registery;
    }

    /**
     * Find and get all animations with the given name.
     * @param name 
     * @returns 
     */
  }, {
    key: "find",
    value: function find(name) {
      var c = this._registery.filter(function (obj) {
        if (obj.name === name) {
          return obj;
        }
      });
      return c;
    }
  }, {
    key: "timeScale",
    value: function timeScale(scale) {
      this.currentTimeScale = scale;
      this._registery.forEach(function (a) {
        a.timeScale(scale);
      });
    }
  }]);
}();
var gameAnimationRegistry = new GameAnimationRegistry();
var _default = exports["default"] = gameAnimationRegistry;
//# sourceMappingURL=GameAnimationRegistry.js.map